export const messages = {
  fr: {
    sorewards: {
      title: 'Carte bancaire',
      obtainCta: 'Obtenir ma carte',
      obtaining: 'Création de votre carte…',
      loadingCard: 'Recherche de votre carte…',
      loadingWidget: 'Ouverture de votre carte…',
      widgetHint: 'Solde, numéro de carte et wallets sont affichés par Sorewards.',
      back: 'Retour',
      retry: 'Réessayer',
      errorTitle: 'Impossible d’afficher la carte',
      createError: 'La création de la carte a échoué.',
      signupError: 'La vérification d’identité a échoué.',
      alreadyExists: 'Une carte est déjà associée à votre compte.',
      notOnboarded: 'Créez d’abord votre carte pour ouvrir le widget.',
      unauthorized: 'Session expirée. Reconnectez-vous pour afficher la carte.',
      forbidden: 'Votre compte n’est pas encore vérifié. Impossible d’ouvrir le widget.',
      scriptFailed: 'Le script du widget Sorewards n’a pas pu être chargé.',
      missingPlatformId: 'Le platform id Sorewards n’est pas configuré.',
      networkError: 'Connexion impossible. Vérifiez votre réseau puis réessayez.',
      missingProgram:
        'Un programme Sorewards doit exister côté administration avant de créer une carte.',
      products: {
        giftCards: 'Cartes cadeaux',
        giftCardsHint: 'Enseignes · parcours eBons de votre dotation',
        bankCard: 'Carte bancaire',
        bankCardHint: 'Carte Virtual Sorewards',
        heading: 'Que faire de votre {brand} ?',
        available: '{amount} disponibles · ce n’est pas un achat d’eBons'
      },
      hub: {
        useDotation: 'Utiliser ma dotation',
        bankCard: 'Ma carte bancaire'
      },
      identity: {
        notice: 'Les informations suivantes sont nécessaires pour procéder à la vérification de votre identité.',
        mobile: 'N° Mobile',
        mobileHint:
          'Utilisé pour sécuriser vos paiements en ligne (3D Secure) et gérer la mise à jour de votre code PIN.',
        mobilePlaceholder: '6 12 34 56 78',
        mobileInvalid: 'Numéro de mobile invalide',
        dialCode: 'Indicatif',
        civility: 'Civilité',
        civilityMr: 'Monsieur',
        civilityMrs: 'Madame',
        residenceCountry: 'Pays de résidence',
        birthDate: 'Date de naissance',
        birthDatePlaceholder: 'JJ/MM/AAAA',
        birthDateMinAge: 'Vous devez avoir au moins 18 ans.',
        required: 'Ce champ est requis'
      }
    }
  },
  en: {
    sorewards: {
      title: 'Payment card',
      obtainCta: 'Get my card',
      obtaining: 'Creating your card…',
      loadingCard: 'Looking up your card…',
      loadingWidget: 'Opening your card…',
      widgetHint: 'Balance, PAN and wallets are shown by the Sorewards widget.',
      back: 'Back',
      retry: 'Try again',
      errorTitle: 'Unable to display the card',
      createError: 'Card creation failed.',
      signupError: 'Identity verification failed.',
      alreadyExists: 'A card is already linked to your account.',
      notOnboarded: 'Create your card first, then open the widget.',
      unauthorized: 'Your session has expired. Sign in again to display the card.',
      forbidden: 'Your account is not verified yet. The widget cannot be opened.',
      scriptFailed: 'The Sorewards widget script could not be loaded.',
      missingPlatformId: 'The Sorewards platform id is not configured.',
      networkError: 'Connection failed. Check your network and try again.',
      missingProgram:
        'A Sorewards program must exist in admin before a card can be created.',
      products: {
        giftCards: 'Gift cards',
        giftCardsHint: 'Brands · eBon flow from your allowance',
        bankCard: 'Payment card',
        bankCardHint: 'Sorewards Virtual card',
        heading: 'What would you like to do with your {brand}?',
        available: '{amount} available · this is not an eBon purchase'
      },
      hub: {
        useDotation: 'Use my allowance',
        bankCard: 'My payment card'
      },
      identity: {
        notice: 'The following information is required to verify your identity.',
        mobile: 'Mobile number',
        mobileHint: 'Used to secure your online payments (3D Secure) and manage your PIN updates.',
        mobilePlaceholder: '6 12 34 56 78',
        mobileInvalid: 'Invalid mobile number',
        dialCode: 'Country code',
        civility: 'Title',
        civilityMr: 'Mr',
        civilityMrs: 'Mrs',
        residenceCountry: 'Country of residence',
        birthDate: 'Date of birth',
        birthDatePlaceholder: 'MM/DD/YYYY',
        birthDateMinAge: 'You must be at least 18 years old.',
        required: 'This field is required'
      }
    }
  }
}
